import type { BBox } from '@/modules/Editor/types'

export const isSameBBox = (a: BBox, b: BBox): boolean =>
  a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height
